(function () {
  var hallPlan = document.querySelector('.js-hall-plan');
  var config = window.meinplanBookingHoldConfig;

  if (!hallPlan) return;

  var zoomButton = hallPlan.querySelector('.js-hall-plan-zoom');
  var zoomLabel = hallPlan.querySelector('.js-hall-plan-zoom-label');

  if (zoomButton) {
    zoomButton.addEventListener('click', function () {
      var isZoomed = hallPlan.classList.toggle('is-zoomed');

      zoomButton.setAttribute('aria-pressed', isZoomed ? 'true' : 'false');
      if (zoomLabel) {
        zoomLabel.textContent = isZoomed ? 'Gesamtansicht' : 'Plan vergrößern';
      }
    });
  }

  if (!config || !config.ajaxUrl || !config.nonce) return;

  var stands = Array.prototype.slice.call(
    hallPlan.querySelectorAll('.js-hall-plan-stand')
  );
  var selection = hallPlan.querySelector('.js-hall-plan-selection');
  var selectionSize = hallPlan.querySelector('.js-hall-plan-selection-size');
  var selectionPackage = hallPlan.querySelector('.js-hall-plan-selection-package');
  var selectionMessage = hallPlan.querySelector('.js-hall-plan-message');
  var input = hallPlan.querySelector('.js-hall-plan-input');
  var bookingButton = hallPlan.querySelector('.js-hall-plan-booking');
  var deselectButton = hallPlan.querySelector('.js-hall-plan-deselect');
  var bookingSection = document.querySelector('[data-anchor="anmeldung"]');
  var bookingStand = document.querySelector('.js-booking-stand');
  var bookingSize = document.querySelector('.js-booking-size');
  var bookingPackage = document.querySelector('.js-booking-package');
  var bookingBack = document.querySelector('.js-booking-back');
  var holdStatuses = Array.prototype.slice.call(
    document.querySelectorAll('.js-booking-hold-status')
  );
  var holdTimers = Array.prototype.slice.call(
    document.querySelectorAll('.js-booking-hold-timer')
  );
  var formStandInput = document.querySelector('#field_meinplan_stand');
  var formStandSizeInput = document.querySelector('#field_meinplan_stand_size');
  var formPackageInput = document.querySelector('#field_meinplan_package');
  var currentHold = null;
  var clock = null;
  var expiryHandled = false;
  var releasePending = false;

  var updateInput = function (field, value) {
    if (!field) return;

    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };

  var getFormSubmitButton = function () {
    return document.querySelector(
      '#form_meinplan-standbuchung .frm_button_submit'
    );
  };

  var setSubmitEnabled = function (enabled) {
    var submitButton = getFormSubmitButton();

    if (submitButton) {
      submitButton.disabled = !enabled;
    }
  };

  var setMessage = function (message, isError, isTransient) {
    if (!selectionMessage) return;

    selectionMessage.textContent = message || '';
    selectionMessage.hidden = !message;
    selectionMessage.classList.toggle('is-error', Boolean(message && isError));
    selectionMessage.classList.toggle('is-transient', Boolean(message && isTransient));
  };

  var setHoldVisible = function (visible) {
    holdStatuses.forEach(function (status) {
      status.hidden = !visible;
    });
  };

  var syncClock = function (serverNow) {
    clock = {
      serverTime: Number(serverNow) * 1000,
      performanceTime: window.performance.now()
    };
  };

  var getServerTime = function () {
    if (!clock) return Date.now();

    return clock.serverTime + (window.performance.now() - clock.performanceTime);
  };

  var formatRemainingTime = function (seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainder = seconds % 60;

    return String(minutes).padStart(2, '0') + ':' + String(remainder).padStart(2, '0');
  };

  var renderTimer = function () {
    if (!currentHold) {
      setHoldVisible(false);
      return;
    }

    var remaining = Math.max(
      0,
      Math.ceil((Number(currentHold.expiresAt) * 1000 - getServerTime()) / 1000)
    );
    var value = formatRemainingTime(remaining);

    holdTimers.forEach(function (timer) {
      timer.textContent = value;
    });
    setHoldVisible(true);

    if (remaining === 0 && !expiryHandled) {
      expiryHandled = true;
      currentHold = null;
      clearSelection('Deine Reservierungsfrist ist abgelaufen. Bitte wähle den Stand erneut aus.');
      fetchStatus();
    }
  };

  var moveToSection = function (anchor, section) {
    if (window.fullpage_api && !document.body.classList.contains('fp-responsive')) {
      window.fullpage_api.moveTo(anchor);
      return;
    }

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  var setStandStatus = function (stand, status, isOwn) {
    var initialStatus = stand.getAttribute('data-initial-status');
    var isPermanent = initialStatus !== 'available' && initialStatus !== 'held';
    var description = stand.getAttribute('data-stand-description');

    if (isPermanent) {
      stand.disabled = true;
      stand.setAttribute('data-status', initialStatus);
      stand.setAttribute(
        'aria-label',
        description + (initialStatus === 'blocked' ? ', vom Veranstalter blockiert' : ', reserviert')
      );
      return;
    }

    if (isOwn) {
      stand.disabled = false;
      stand.setAttribute('data-status', 'held-own');
      stand.setAttribute('aria-label', description + ', für dich reserviert');
      return;
    }

    if (status === 'held') {
      stand.disabled = true;
      stand.setAttribute('data-status', 'held');
      stand.setAttribute('aria-label', description + ', vorübergehend reserviert');
      return;
    }

    stand.disabled = false;
    stand.setAttribute('data-status', 'available');
    stand.setAttribute('aria-label', description + ', verfügbar');
  };

  var applySelection = function (stand) {
    if (!stand || stand.disabled || !currentHold) return;

    stands.forEach(function (item) {
      var isSelected = item === stand;

      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    var standId = stand.getAttribute('data-stand-id');
    var standWidth = stand.getAttribute('data-stand-width');
    var standHeight = stand.getAttribute('data-stand-height');
    var standUnit = stand.getAttribute('data-stand-unit');
    var standPackage = stand.getAttribute('data-stand-package');
    var formattedSize = standWidth + ' × ' + standHeight + ' ' + standUnit;

    input.value = standId;
    selection.textContent = 'Stand ' + standId;
    selectionSize.textContent = formattedSize;
    selectionPackage.textContent = standPackage;
    bookingStand.textContent = 'Stand ' + standId;
    bookingSize.textContent = formattedSize;
    bookingPackage.textContent = standPackage;
    bookingButton.disabled = false;
    if (deselectButton) {
      deselectButton.hidden = false;
    }
    setSubmitEnabled(true);
    updateInput(formStandInput, standId);
    updateInput(formStandSizeInput, formattedSize);
    updateInput(formPackageInput, standPackage);
    renderTimer();

  };

  var clearSelection = function (message) {
    stands.forEach(function (stand) {
      stand.classList.remove('is-selected');
      stand.setAttribute('aria-pressed', 'false');
    });

    input.value = '';
    selection.textContent = 'Noch keinen Stand gewählt';
    selectionSize.textContent = '';
    selectionPackage.textContent = '';
    bookingStand.textContent = 'Noch keinen Stand gewählt';
    bookingSize.textContent = '';
    bookingPackage.textContent = '';
    bookingButton.disabled = true;
    if (deselectButton) {
      deselectButton.hidden = true;
      deselectButton.disabled = false;
    }
    setSubmitEnabled(false);
    setHoldVisible(false);
    updateInput(formStandInput, '');
    updateInput(formStandSizeInput, '');
    updateInput(formPackageInput, '');
    setMessage(message || '', Boolean(message));
  };

  var postAction = function (action, values) {
    var body = new URLSearchParams({
      action: action,
      nonce: config.nonce
    });

    Object.keys(values || {}).forEach(function (key) {
      body.set(key, values[key]);
    });

    return window
      .fetch(config.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: body.toString()
      })
      .then(function (response) {
        return response.text().then(function (body) {
          var payload;

          try {
            payload = JSON.parse(body);
          } catch (error) {
            throw new Error(
              'Der Reservierungsserver hat keine gültige Antwort geliefert. Bitte lade die Seite neu und versuche es erneut.'
            );
          }

          if (!response.ok || !payload.success) {
            var error = new Error(
              payload.data && payload.data.message
                ? payload.data.message
                : 'Die Standreservierung konnte nicht aktualisiert werden.'
            );

            error.status = payload.data && payload.data.status;
            throw error;
          }

          return payload.data;
        });
      });
  };

  var applyStatus = function (status) {
    if (!status) return;

    syncClock(status.serverNow);

    var heldStands = new Set(status.heldStands || []);
    var ownHold = status.ownHold || null;

    stands.forEach(function (stand) {
      var standId = stand.getAttribute('data-stand-id');

      setStandStatus(
        stand,
        heldStands.has(standId) ? 'held' : 'available',
        Boolean(ownHold && ownHold.standId === standId)
      );
    });

    if (!ownHold) {
      if (currentHold || input.value) {
        currentHold = null;
        clearSelection('Deine Reservierungsfrist ist abgelaufen. Bitte wähle den Stand erneut aus.');
      }

      return;
    }

    var ownStand = stands.find(function (stand) {
      return stand.getAttribute('data-stand-id') === ownHold.standId;
    });

    if (!ownStand || ownStand.disabled) {
      currentHold = null;
      clearSelection();
      return;
    }

    currentHold = ownHold;
    expiryHandled = false;
    setMessage();
    applySelection(ownStand);
  };

  var fetchStatus = function () {
    return postAction(config.statusAction)
      .then(function (status) {
        applyStatus(status);
        return status;
      })
      .catch(function () {
        if (!currentHold) {
          setMessage('Der Reservierungsstatus konnte gerade nicht geladen werden.', true);
        }

        return null;
      });
  };

  var acquireStand = function (stand) {
    if (
      !stand ||
      stand.disabled ||
      releasePending ||
      stand.classList.contains('is-pending')
    ) return;

    stand.classList.add('is-pending');
    setMessage('Stand wird kurz für dich reserviert …', false, true);

    postAction(config.acquireAction, {
      stand_id: stand.getAttribute('data-stand-id')
    })
      .then(function (status) {
        applyStatus(status);
        setMessage();
      })
      .catch(function (error) {
        if (error.status) {
          applyStatus(error.status);
        }

        setMessage(error.message, true);
      })
      .finally(function () {
        stand.classList.remove('is-pending');
      });
  };

  var releaseSelection = function () {
    if (releasePending || !currentHold || !input.value || !config.releaseAction) return;

    var standId = input.value;

    releasePending = true;
    if (deselectButton) {
      deselectButton.disabled = true;
    }
    setMessage('Auswahl wird aufgehoben …', false, true);

    postAction(config.releaseAction, { stand_id: standId })
      .then(function (status) {
        currentHold = null;
        expiryHandled = false;
        clearSelection();
        applyStatus(status);
        setMessage('Auswahl aufgehoben.');
      })
      .catch(function (error) {
        if (deselectButton) {
          deselectButton.disabled = false;
        }
        setMessage(error.message, true);
      })
      .finally(function () {
        releasePending = false;
      });
  };

  stands.forEach(function (stand) {
    stand.addEventListener('click', function () {
      if (stand.classList.contains('is-selected')) {
        releaseSelection();
        return;
      }

      acquireStand(stand);
    });

    stand.addEventListener('pointermove', function (event) {
      var bounds = stand.getBoundingClientRect();

      stand.style.setProperty('--stand-shimmer-x', event.clientX - bounds.left + 'px');
      stand.style.setProperty('--stand-shimmer-y', event.clientY - bounds.top + 'px');
    });
  });

  bookingButton.addEventListener('click', function () {
    if (!input.value || !currentHold) return;

    moveToSection('anmeldung', bookingSection);
  });

  if (deselectButton) {
    deselectButton.addEventListener('click', releaseSelection);
  }

  bookingBack.addEventListener('click', function () {
    moveToSection('hallenplan', hallPlan.closest('.front-page__panel'));
  });

  setSubmitEnabled(false);
  window.setInterval(renderTimer, 1000);
  window.setInterval(fetchStatus, Number(config.statusInterval) || 15000);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      fetchStatus();
    }
  });

  var requestedStand =
    new URLSearchParams(window.location.search).get('stand') ||
    (formStandInput ? formStandInput.value : '');

  fetchStatus().then(function (status) {
    if (!status || status.ownHold || !requestedStand) return;

    var matchingStand = stands.find(function (stand) {
      return stand.getAttribute('data-stand-id') === requestedStand.toUpperCase();
    });

    acquireStand(matchingStand);
  });

  if (window.jQuery) {
    window.jQuery(document).on('frmFormComplete', function (event, form) {
      if (!form || !form.attr || form.attr('id') !== 'form_meinplan-standbuchung') {
        return;
      }

      var selectedStand = stands.find(function (stand) {
        return stand.getAttribute('data-stand-id') === input.value;
      });

      if (selectedStand) {
        var standContent = selectedStand.querySelector(
          '.hall-plan__stand-logo-frame, .hall-plan__stand-company, .hall-plan__stand-info'
        );
        var reservedLabel = document.createElement('span');
        var tooltip = selectedStand.querySelector('.hall-plan__stand-tooltip');

        reservedLabel.className = 'hall-plan__stand-company';
        reservedLabel.textContent = 'Reserviert';

        if (standContent) {
          standContent.replaceWith(reservedLabel);
        } else {
          selectedStand.appendChild(reservedLabel);
        }

        if (tooltip) {
          tooltip.textContent = 'Reserviert';
        }

        selectedStand.classList.remove('is-selected');
        selectedStand.classList.add('hall-plan__stand--assigned');
        selectedStand.setAttribute('data-status', 'reserved');
        selectedStand.setAttribute('data-initial-status', 'reserved');
        selectedStand.setAttribute(
          'aria-label',
          selectedStand.getAttribute('data-stand-description') + ', reserviert'
        );
        selectedStand.setAttribute('aria-pressed', 'false');
        selectedStand.disabled = true;
      }

      currentHold = null;
      clearSelection();
    });
  }
})();
